const authentication = (ui) => {
  return {
    basic ({ username, password }) {
      return ui.http.post(`auth/login`, { username, password })
        .then(body => {
            window.location.reload();
            return body && body.data
        }
        )
        .catch(body => body.response.data)
    }
  }
}

export default { authentication }
